import ItemClasificacion from './itemclasificacion.vue';
import ItemClasificacionForm from './itemclasificacion-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/itemclasificacion/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemclasificacion', ['ADMIN', 'DTYCAL'], ItemClasificacion),
        keepAlive: true
    },
    {
        path: '/itemclasificacion/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemclasificacion/new', ['ADMIN', 'DTYCAL'], ItemClasificacionForm)
    },
    {
        path: '/itemclasificacion/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemclasificacion/edit', ['ADMIN', 'DTYCAL'], ItemClasificacionForm)
    },
    {
        path: '/itemclasificacion/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemclasificacion/view', ['ADMIN', 'DTYCAL'], ItemClasificacionForm, { editable: false })
    },
];
export default routes;
